import { render, staticRenderFns } from "./EmailLists.vue?vue&type=template&id=e1346674&scoped=true&"
import script from "./EmailLists.vue?vue&type=script&lang=js&"
export * from "./EmailLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1346674",
  null
  
)

export default component.exports